import script from "./MyClub.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyClub.vue?vue&type=script&lang=ts&setup=true"

import "./MyClub.vue?vue&type=style&index=0&id=21375ceb&lang=scss&scoped=true"
script.__scopeId = "data-v-21375ceb"

export default script